export default {
  '&EAAdvocacyForm.Prefix': 'Título',
  '&EAAdvocacyForm.FirstName': 'Nombre',
  '&EAAdvocacyForm.MiddleName': 'Segundo nombre',
  '&EAAdvocacyForm.LastName': 'Apellido',
  '&EAAdvocacyForm.Suffix': 'Sufijo',
  '&EAAdvocacyForm.EmailAddress': 'Correo',
  '&EAAdvocacyForm.MobilePhone': 'Teléfono Móvil',
  '&EAAdvocacyForm.PostalCode': 'Código Postal',
  '&EAAdvocacyForm.Consent': 'Quiero recibir actualizaciones de The Humane League México',
  '&EAAdvocacyForm.Country': 'País',
  '&EAAdvocacyForm.NextStep': ' Continuar >',
  '&EAAdvocacyForm.PreviousStep': 'Volver',
  '&EAAdvocacyForm.Subject': 'Asunto',
  '&EAAdvocacyForm.Message': 'Mensaje',
  '&EAAdvocacyForm.Submit': 'Enviar',
  '&EAAdvocacyForm.InfoConsent':
    'Mantén esta casilla seleccionada si quieres recibir actualizaciones de nuestras campañas y sencillas acciones que puedes realizar por los animales. Puedes darte de baja en cualquier momento.',
  '&EAAdvocacyForm.InfoConsentSms':
    'Mantenga esta casilla marcada si desea recibir alertas SMS (texto) ocasionales de The Humane League, incluidas actualizaciones de campaña y alertas de acción. Puede optar por no participar en cualquier momento.',
  '&EAAdvocacyForm.ConsentSms': 'Enviarme alertas SMS ocasionales',
  '&EAAdvocacyForm.EditYourMessage': 'Edita tu mensaje',
  '&EAAdvocacyForm.ReadOrEditYourMessage': 'LEE/EDITA TU MENSAJE',
  '&EAAdvocacyForm.DoneReadingOrEditingYourMessage': 'Hecho',
  '&EAAdvocacyForm.SignNow': 'ENVIAR',
  '&EAAdvocacyForm.AcceptPrivacyPolicyPrefix': 'He leído y acepto el',
  '&EAAdvocacyForm.AcceptPrivacyPolicyLinkText': 'aviso de privacidad',
  '&EAAdvocacyForm.AcceptPrivacyPolicyLinkUrl': 'https://thehumaneleague.mx/politica-de-privacidad',
  '&EAAdvocacyForm.AcceptPrivacyPolicyErrorNotChecked': 'Debe aceptar enviar.',
} as TextDictionary;
